module.exports = __webpack_public_path__ + "img/haiti.061ba22.webp";